<div>
    <span  class="subcategory-label pull-right" [ngStyle]="getCategoryColor()" >{{categoryLabel}}</span>
</div>
<p-table auto="upload-table" *ngIf="subcategory.files; else subcategoryLabel"  [value]="subcategory.files"  styleClass="category-table subcategory-table rounded-table"
selectionMode="single" >
<ng-template pTemplate="header">
  <tr class="title-head" style="border-radius: 6px 0 6px 6px;">
    <th class="attachment-name">Attachment Name</th>
    <th class="attachment-description">Attachment Description</th>
    <th class="attachment-details">Attachment Details</th>
    <!-- Removed classes fa fa-paperclip flip-90 -->
    <th class="zero-border">
      <button *ngIf="!isViewer" class='pull-right attachment-btn pointer' (click)="displayAttachmentModal()" pTooltip="Add Attachment(s)" tooltipPosition="bottom" tooltipStyleClass="subheader-item-tooltip">
        <img src="assets/images/attachment-icon-white.svg">
      </button>
    </th>
  </tr>
</ng-template>
<ng-template pTemplate="body" let-attachment>
  <tr [pSelectableRow]="attachment"
      [ngClass]="{'no-divider': true, 'placeholder-row': isPlaceholder(attachment)}">
    <td class="title-column" valign="top">
      <div class='attachment-pointer' *ngIf="attachment.name">
        <div class="attachment-icon-container">
          <img class="attachment-icon" class="height-20" [src]="iconImageSrc(attachment)" tooltipStyleClass="strategies-tooltip"
            [alt]="altText(attachment)" [pTooltip]="altText(attachment)">
        </div>
        <span class="attachment-name-container" (click)="onClickAttachmentName(attachment)">
            <a  class="pointer underline attachment-name">{{attachment.name}}</a>
        </span>
      </div>
    </td>
    <td valign="top">
      <div class="attachment-pointer">
        {{attachment.description}}
      </div>
    </td>
    <td valign="top">
        <div class="attachmentDetails">
            <span class="bold">{{attachment.createdUserFirstName}} {{attachment.createdUserLastName}}</span>
          <span><i>{{formattedDate(attachment.createdDateTime)}}</i></span>
            </div>
    </td>
    <td class="actions-icons" valign="top">
      <div *ngIf="attachment.name">
      <button
        *ngIf="!isViewer"
        auto="upload-edit-btn"
        class="fa fa-pencil pointer"
        pTooltip="Edit Attachment(s)"
        tooltipStyleClass="subheader-item-tooltip"
        tooltipPosition="bottom"
        tooltipEvent="hover"
        appendTo="body"
        (click)="displayEditAttachmentModal(attachment)">
      </button>
      <button
        *ngIf="!isViewer"
        auto="upload-delete-btn"
        [attr.attachment]="attachment"
        class="fa fa-trash pointer"
        pTooltip="Delete Attachment(s)"
        tooltipStyleClass="subheader-item-tooltip"
        tooltipPosition="bottom"
        tooltipEvent="hover"
        (click)="displayDeleteModal(attachment, attachment.name)">
      </button>
    </div>
    </td>
  </tr>
</ng-template>
</p-table>
<ng-template #subcategoryLabel>
    <p-table auto="upload-table"  styleClass="priorities-table rounded-zebra-table"
    [value]="subcategory" selectionMode="single">
        <ng-template pTemplate="header">
            <tr class="title-head" style="border-radius: 6px 0 6px 6px;">
              <th class="attachment-name">Attachment Name</th>
              <th class="attachment-description">Attachment Description</th>
              <th class="attachment-details">Attachment Details</th>
              <th class="zero-border"> <button class='pull-right attachment-btn pointer' (click)="displayAttachmentModal(subcategory.value)">
                <img src="assets/images/attachment-icon-white.svg">
              </button></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" >
            <tr>
              <td class="title-column"><div></div></td>
              <td class="attachment-pointer"></td>
              <td></td>
              <td></td>
            </tr>
          </ng-template>
    </p-table>
</ng-template>
